

define(['angular', 'squid/index', 'components/xo-beaver/dist/logger', 'components/xo-models/src/user/index', 'components/xo-models/src/checkout/index', 'components/xo-models/src/inventory/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-landing.route', ['squid', 'beaver', 'xomodel.user']).factory('$LandingRoute', function ($ComponentRoute, $dispatch, $feature, $logger, $locale, $util, $FallbackError, $meta, $pxp, $CheckoutInputDataModel, $CheckoutAppDataModel, $rootScope, $populate, $config, $CheckoutCartModel, $CheckoutPayeeModel, $InventoryModel, $FlowEligibilityModel) {

        // controller is added in squid/route.js
        return $ComponentRoute.extend('LandingRoute', {
            name: 'landing',
            titleContent: 'accountCreationGuest.heading',
            scope: {
                isUnbranded: '='
            },
            trackingData: {
                fptiState: 'landing',
                trackStateExit: true
            },
            resolve: {
                action: function action($util) {
                    // eslint-disable-line no-shadow

                    var models = {};
                    return $populate(models, {
                        checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                        checkoutPayeeModel: $CheckoutPayeeModel.instance($rootScope.token),
                        checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                        checkoutInputData: $CheckoutInputDataModel.instance($rootScope.token)
                    }).then(function () {
                        // C2 ramp - force CN country code to C2 upon landing
                        if ($locale.country === 'CN') {
                            $locale.change('C2', $locale.lang);
                            $logger.info('CN_locale_forced_to_C2');
                        }
                    }).then(function () {
                        var landingFlow = function landingFlow() {

                            function callEPM() {
                                if ($config.deploy.isLocal() || $config.deploy.isStage()) {
                                    var passedInExp = $util.param('showExp');
                                    if ('guest'.indexOf(passedInExp) > -1) {
                                        return 'checkout.guest';
                                    }

                                    if ('signup'.indexOf(passedInExp) > -1) {
                                        return 'checkout.signup';
                                    }
                                }
                                return $FlowEligibilityModel.instance($rootScope.token).retrieve({
                                    params: {
                                        'localeCountry': $locale.country
                                    }
                                }).then(function (flowEligibility) {
                                    var mode = flowEligibility.guest ? 'guest' : 'signup';
                                    if (mode === 'signup') {
                                        $logger.info(mode + '_flow_offered_by_epm_at_route');
                                        return 'checkout.signup';
                                    }
                                    $logger.info('guest_flow_offered_by_epm_at_route');
                                    return 'checkout.guest';
                                });
                            }

                            var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                            var paymentMethodViaUrl = $util.param('paymentMethod');
                            var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;

                            var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
                            var isUnbranded = paymentMethod !== undefined;

                            if (isUnbranded) {
                                var isUnbrandedAllowed = $feature('unbranded', true, merchantCountry);
                                var isPuiAllowed = $feature('invoicePayment', true, merchantCountry);

                                if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
                                    return 'checkout.pay-upon-invoice';
                                }
                                return 'checkout.guest';
                            } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && $util.param('exp') === 'signup') {
                                return 'checkout.signup';
                            } else if ($feature('multiStepSignup', false, $locale.country)) {
                                return 'checkout.multistepsignup';
                            } else if (models.checkoutInputData.isEbayTxn()) {
                                // force signup for eBay users
                                $logger.info('ebay_flow_signup');
                                return 'checkout.signup';
                            } else {
                                // if you here means, now we need to determine the route based on symphony EPM call.
                                return callEPM();
                            }
                        };

                        var cartHasInventory = models.checkoutCart.get('cartHasInventory');
                        if ($config.enableInventoryWPS && cartHasInventory) {
                            var inventoryModel = $InventoryModel.instance($rootScope.token);
                            var inventoryInput = {
                                items: models.checkoutCart.get('purchase.items'),
                                merchantId: models.checkoutPayeeModel.getId()
                            };
                            return inventoryModel.action('getInventory', {
                                data: inventoryInput,
                                success: function success(inventoryResponse) {
                                    if (inventoryResponse.showSoldoutPage) {
                                        return {
                                            to: 'checkout.soldout',
                                            params: {
                                                items: encodeURIComponent(inventoryResponse.soldoutItems),
                                                soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                            }
                                        };
                                    } else {
                                        inventoryModel.setInvetoryItems(inventoryResponse);
                                        return landingFlow();
                                    }
                                }
                            });
                        } else {
                            return landingFlow();
                        }
                    });
                }
            }
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 1